import React from 'react';
import styled from 'styled-components';

interface Props {
  width: number;
  height: number;
  url: string;
  alt?: string;
}

const Image = styled.div`
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  object-fit: cover;
`;

const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2e8bd7 0%, #78b8f5 100%);
  color: white;
  font-weight: 700;
  letter-spacing: 0.08em;
`;

const getInitials = (value?: string) => {
  if (!value) {
    return '';
  }

  return value
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() ?? '')
    .join('');
};

export function CroppedImage({ width, height, url, alt }: Props) {
  const initials = getInitials(alt);

  if (!url) {
    return (
      <Placeholder
        style={{ width, height, fontSize: Math.max(24, Math.floor(width / 4)) }}
        title={alt}
      >
        {initials}
      </Placeholder>
    );
  }

  return (
    <Image
      style={{
        backgroundImage: `url(${url})`,
        width,
        height
      }}
      title={alt}
    />
  );
}
